import { cn } from '@/lib/utils';

export type KpiTone = 'default' | 'accent' | 'alert';

interface KpiTileProps {
  label: string;
  value: string;
  hint?: string;
  tone?: KpiTone;
  /** Smaller figure, for "now → after" values that don't fit the KPI size. */
  compact?: boolean;
}

const TONE_BORDER: Record<KpiTone, string> = {
  default: '',
  accent: 'border-adv-gold',
  alert: 'border-adv-warning',
};

/** KPI card of the report: label, figure and an optional line under it. */
export function KpiTile({ label, value, hint, tone = 'default', compact = false }: KpiTileProps) {
  return (
    <div className={cn('adv-card adv-card--kpi px-4 py-4 min-w-0', TONE_BORDER[tone])}>
      <p className="adv-kpi__label truncate" title={label}>
        {label}
      </p>
      <p
        className={cn(
          compact ? 'mt-2 adv-num text-adv-body-l font-bold' : 'mt-2 adv-kpi__value',
          tone === 'alert' ? 'text-adv-warning-text' : 'text-adv-primary'
        )}
      >
        {value}
      </p>
      {hint && <p className="text-adv-body-s text-adv-tertiary mt-1">{hint}</p>}
    </div>
  );
}
